import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appExpandingTextbox]',
    standalone: false
})
export class ExpandingTextboxDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLTextAreaElement>) { }

  ngAfterViewInit(): void {
    this.adjustHeight();
    setTimeout(() => this.adjustHeight(), 0);
  }

  @HostListener('input') adjustHeight(): void {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
}
